export class Tutorial {
    cid:number;
    title:string;
    description:string;
    order:number;
    label: string;
    type: string;
    path: string;
}